import { PageType } from "~/lib/router/enums";

export const pathname = "/posties/video";

export const page = {
  route(query: QueryParameters<{ entityId?: string }>) {
    return { cacheMaxAge: 60, pathname, query: { ...query, pageType: PageType.PostiesVideo } };
  },
};
